import React from 'react';
import { useSimulation } from '../context/SimulationContext';
import AccountCard from '../components/dashboard/AccountCard';
import PositionTable from '../components/dashboard/PositionTable';
import PositionCard from '../components/mobile/PositionCard';
import ProfitChart from '../components/dashboard/ProfitChart';
import StrategyStatus from '../components/dashboard/StrategyStatus';
import Card from '../components/common/Card';
import useIsMobile from '../hooks/useIsMobile';

const DashboardPage = () => {
  const { account, positions, flashingCells } = useSimulation();
  const isMobile = useIsMobile();

  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="text-2xl sm:text-3xl font-bold">대시보드</h2>

      <AccountCard account={account} />

      {/* 포지션 섹션 - 모바일/데스크톱 분기 */}
      {isMobile ? (
        <div>
          <h3 className="text-lg font-bold mb-3">현재 포지션</h3>
          <div>
            {positions.map((position) => (
              <PositionCard
                key={position.id}
                position={position}
                flashingCells={flashingCells}
              />
            ))}
          </div>
        </div>
      ) : (
        <Card title="현재 포지션">
          <PositionTable positions={positions} flashingCells={flashingCells} />
        </Card>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
        <div className="lg:col-span-2">
          <Card title="수익률 추이">
            <ProfitChart />
          </Card>
        </div>
        <div>
          <StrategyStatus />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
